import { Skeleton } from "@mui/material";

const LoadingPlayer: React.FC = () => {
  return (
    <Skeleton
      className="noscript-nodisplay"
      variant="rectangular"
      sx={{ aspectRatio: 16 / 9, width: "100%", height: "auto", overflow: "hidden" }}
    />
  );
};

export default LoadingPlayer;
